/**
 * This is to indicate where requests are processed so the environment can
 * correctly build the contextId for items produced by workflows or items that
 * came from upstream runtimes
 */
export var RuntimeKind;
(function (RuntimeKind) {
    RuntimeKind["JsClient"] = "C";
    RuntimeKind["Server"] = "S";
})(RuntimeKind || (RuntimeKind = {}));
//# sourceMappingURL=runtime-kind.js.map